import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { PageLoader, EmptyState } from "@/components/Loading";
import { Trophy, Medal, Crown, TrendingUp } from "lucide-react";

export default function Leaderboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/leaderboard").then((r) => setData(r.data)).catch(() => setData(false)); }, []);
  if (data === null) return <PageLoader />;
  if (data === false) return <EmptyState icon={Trophy} title="تعذّر تحميل الترتيب" />;

  const medal = (i) => i === 0 ? "text-yellow-500" : i === 1 ? "text-slate-400" : i === 2 ? "text-amber-700" : "text-slate-300";

  return (
    <>
      <PageHeader title="لوحة الترتيب" subtitle={`ترتيبك العلمي داخل وحدتك السكنية${data.unit_name ? " — " + data.unit_name : ""}`} />
      <div className="mb-6 grid gap-4 sm:grid-cols-3">
        <div className="rounded-2xl bg-navy p-6 text-white soft-shadow">
          <div className="flex items-center gap-2 text-slate-300"><Crown className="h-5 w-5 text-gold" /><span className="text-sm">ترتيبك في الوحدة</span></div>
          <p className="mt-3 font-heading text-5xl font-extrabold text-gold" data-testid="my-rank">{data.position} <span className="text-xl text-slate-300">من {data.total}</span></p>
        </div>
        <div className="rounded-2xl border border-slate-100 bg-card p-6 soft-shadow">
          <div className="flex items-center gap-2 text-navy"><TrendingUp className="h-5 w-5" /><span className="text-sm">الفرق عن المركز الأعلى</span></div>
          <p className="mt-3 font-heading text-4xl font-extrabold text-greenx">{data.gap_to_next}</p>
          <p className="mt-1 text-xs text-slate-400">نقطة تفصلك عن المركز الذي يسبقك</p>
        </div>
        <div className="rounded-2xl border border-slate-100 bg-card p-6 soft-shadow">
          <div className="flex items-center gap-2 text-navy"><Trophy className="h-5 w-5 text-gold" /><span className="text-sm">عدد طلاب وحدتك</span></div>
          <p className="mt-3 font-heading text-4xl font-extrabold text-navy">{data.total}</p>
        </div>
      </div>

      <div className="rounded-2xl border border-slate-100 bg-card soft-shadow overflow-hidden">
        <div className="border-b border-slate-100 p-5 font-heading text-lg font-bold text-navy">المراكز الأولى في وحدتك</div>
        <div className="divide-y divide-slate-50">
          {data.top.map((t, i) => (
            <div key={i} data-testid={`rank-row-${i}`} className={`flex items-center justify-between px-5 py-4 ${t.is_me ? "bg-gold/5" : ""}`}>
              <div className="flex items-center gap-4">
                <div className={`flex h-9 w-9 items-center justify-center rounded-xl bg-slate-50 font-bold ${medal(i)}`}>
                  {i < 3 ? <Medal className="h-5 w-5" /> : <span className="text-sm text-slate-500">{i + 1}</span>}
                </div>
                <div>
                  <p className="font-semibold text-navy">{t.name} {t.is_me && <span className="text-xs text-gold-dark">(أنت)</span>}</p>
                  <p className="text-xs text-slate-400">{t.level_title}</p>
                </div>
              </div>
              <span className="font-heading text-lg font-bold text-greenx">{t.points} نقطة</span>
            </div>
          ))}
        </div>
      </div>
      <p className="mt-4 text-center text-xs text-slate-400">الهدف من الترتيب هو التحفيز والتشجيع على النشاط العلمي 🌱</p>
    </>
  );
}
